import React from 'react';
import classNames from 'classnames';

// Local Styles
import './styles.scss';

interface Props {
    children: React.ReactNode;
    noAdjacentText?: boolean;
}

/**
 * A component for wrapping around icons placed within buttons.
 * It ensures that the icon is placed correctly.
 */
export class ButtonIconWrapperComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { children, noAdjacentText } = this.props;

        return (
            <div
                className={classNames('button-icon-wrapper', {
                    'no-adjacent-text': noAdjacentText
                })}
            >
                <div className="button-icon-wrapper-inner">{children}</div>
            </div>
        );
    }
}

export default ButtonIconWrapperComponent;
